import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import { 
  rabbyWallet,
  trustWallet,
  walletConnectWallet,
  injectedWallet,
  metaMaskWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { bsc, bscTestnet } from 'wagmi/chains';
import { createConfig, http } from 'wagmi';

// WalletConnect Project ID - Read from env var (drop-in ready)
// If missing/empty, WalletConnect will be disabled in TipQRPage
export const WALLETCONNECT_PROJECT_ID = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || '';

// Check if WalletConnect is available
export const isWalletConnectAvailable = () => Boolean(WALLETCONNECT_PROJECT_ID);

// Detect if we're in a mobile browser
const isMobileBrowser = typeof window !== 'undefined' && /Mobile|Android|iPhone|iPad/i.test(navigator.userAgent || '');

// Detect if we're running as installed PWA (standalone)
export const isPWAStandalone = typeof window !== 'undefined' && (
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
);

// Detect if we're already inside a wallet's in-app browser
const isInWalletBrowser = typeof window !== 'undefined' && (
  window.ethereum?.isMetaMask ||
  window.ethereum?.isTrust ||
  window.ethereum?.isRabby ||
  window.ethereum?.isCoinbaseWallet
);

// WALLET STRATEGY:
// - PWA standalone mode: WalletConnect ONLY (injected providers don't work in standalone PWAs)
// - Mobile wallet browser: injectedWallet works directly
// - Mobile regular browser: MetaMask/Trust deep links + WalletConnect
// - Desktop: all wallets
let walletList;

if (isPWAStandalone && !isInWalletBrowser) {
  // PWA standalone: only WalletConnect works (no window.ethereum)
  walletList = WALLETCONNECT_PROJECT_ID
    ? [walletConnectWallet]
    : [injectedWallet]; // fallback if no WC project ID
} else if (isMobileBrowser) {
  // Mobile browser: WalletConnect first (reliable on all iOS/Android).
  // MetaMask removed — its deep link is broken on older iOS Safari.
  // Users select MetaMask from the WalletConnect wallet list instead.
  walletList = [
    ...(WALLETCONNECT_PROJECT_ID ? [walletConnectWallet] : []),
    trustWallet,
    injectedWallet,
  ];
} else {
  // Desktop
  walletList = [
    rabbyWallet,
    injectedWallet,
    metaMaskWallet,
    trustWallet,
    ...(WALLETCONNECT_PROJECT_ID ? [walletConnectWallet] : []),
  ];
}

const connectors = connectorsForWallets(
  [
    {
      groupName: isPWAStandalone ? 'Connect' : 'Recommended',
      wallets: walletList,
    },
  ],
  {
    appName: 'TipMe',
    projectId: WALLETCONNECT_PROJECT_ID || 'placeholder',
  }
);

// Always use createConfig - NO getDefaultConfig (avoids RainbowKit defaults)
export const config = createConfig({
  connectors,
  chains: [bsc, bscTestnet],
  transports: {
    [bsc.id]: http(),
    [bscTestnet.id]: http(),
  },
});

export const CONTRACTS = {
  bsc: {
    tipToken: process.env.REACT_APP_TIP_TOKEN_ADDRESS || '0x45D8e90deFB7a88C3e5584043205da5a90a43A34',
    factory: process.env.REACT_APP_FACTORY_ADDRESS || '',
  },
  bscTestnet: {
    tipToken: process.env.REACT_APP_TIP_TOKEN_ADDRESS || '',
    factory: process.env.REACT_APP_FACTORY_ADDRESS || '',
  }
};

export const TREASURY_ADDRESS = process.env.REACT_APP_TREASURY_ADDRESS || '0xcAD86262Df9fe4333cD923f7321757E910A0447F';
